import { createIcon } from '@chakra-ui/react';

export const Info = createIcon({
  displayName: 'Info',
  viewBox: '0 0 11 11',
  path: (
    <path
      id="Info"
      data-name="Info"
      d="M6,.5A5.5,5.5,0,1,0,11.5,6,5.5,5.5,0,0,0,6,.5Zm0,9.9A4.4,4.4,0,1,1,10.4,6,4.4,4.4,0,0,1,6,10.4ZM6,5.24a.32.32,0,0,0-.32.32V8.77a.32.32,0,0,0,.64,0V5.56A.32.32,0,0,0,6,5.24ZM6,3.36a.5.5,0,1,0,.49.49A.49.49,0,0,0,6,3.36Z"
      transform="translate(-0.5 -0.5)"
      fill="currentColor"
    />
  ),
});
